import { commonProposalFormApplicationMapper } from "./commonProposalFormApplicationMapper";
import * as lookup from "../../../../../static/lookup.json"
import { getAge } from "../../helperFunctions"
import {valueParser, fullNameCoverter, policyTermValue, repeatableJsonArrayMapper} from "../../dataLayerMapper"

export function stringPath(o, s) {
  s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  s = s.replace(/^\./, '');           // strip a leading dot
  var a = s.split('.');
  // console.log(a, "a")
  for (var i = 0, n = a.length; i < n; ++i) {

    var k = a[i];
    // console.log(k, "k")
    if (k in o) {
      // console.log("inside if main")
      o = o[k];
      // console.log("inner o", o)
      if (!o) {
        // console.log("inside inner if")
        return ""
      }
    } else {
      // console.log("inside else")
      return "";
    }
  }
  return o;
}

export function fundValueJson(payload) {
  let fund = []
  let nVestFundValue = []
  let fundJson = lookup['promise4GrowthfundValue']['fundMapping']

  if (!fundJson)
    return fund
    Object.keys(fundJson).forEach(path => {
    if (stringPath(payload, path)) {

      let fundName
      let value
      let allocationPercentage
      fundName = stringPath(payload, path)
      if (fundName) {
        value = fundJson[path].fundName
        allocationPercentage = stringPath(payload, fundJson[path].allocationPath)
        let obj = {
          "fundName": value,
          "allocationPercent": allocationPercentage
        }
        let obj1 = {
          "fundId": value,
          "fundPercent": allocationPercentage
        }
        fund.push(obj)
        nVestFundValue.push(obj1)
      }
    }
    else {
      let value
      let allocationPercentage
      value = fundJson[path].fundName
      allocationPercentage = parseInt("0")
      let obj1 = {
        "fundId": value,
        "fundPercent": allocationPercentage
      }
      nVestFundValue.push(obj1)
    }

  })
  let fundValue = [
    fund,
    nVestFundValue
  ]
  return fundValue
}

export function guaranteedFutureMapper(payload, journeyId, pageId, sectionId,applicationJSON2 ){
    let pageIndicator = pageId + "." + sectionId 
    if (pageId === "PageGuaranteedFutureViewBenefitIllustration" && payload?.hasOwnProperty("PageGuaranteedFutureViewBenefitIllustration")){
      const benefitPageObject = payload["PageGuaranteedFutureViewBenefitIllustration"]
      if (benefitPageObject?.hasOwnProperty("SectionGuaranteedFuturePersonelDetails") 
        || benefitPageObject?.hasOwnProperty("SectionCommonResidenceAndOccupation")){
        payload["PageGuaranteedFutureCalculatePremium"] = {
          ...payload["PageGuaranteedFutureViewBenefitIllustration"]
        }
      }
    }
    let laAndProposerSame =  valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFuturePersonelDetails", "GOPAslifetobeAssuredandProposer")
    let emailID
    let mobileNo
    let countryCode
    let proposerfirstName =''
    let proposermiddleName =''
    let proposerlastName =''
    if(laAndProposerSame === "N"){
        emailID = valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFuturePersonelDetails", "GOPAproposerEmail")?.toUpperCase()
        mobileNo = valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFuturePersonelDetails", "GOPAnumber")
        countryCode =  valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFuturePersonelDetails", "GOPAproposerCode")
        proposerfirstName =  fullNameCoverter(valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFuturePersonelDetails", "GOPAProposername")).firstName 
        proposermiddleName = fullNameCoverter(valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFuturePersonelDetails", "GOPAProposername")).middleName
        proposerlastName =   fullNameCoverter(valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFuturePersonelDetails", "GOPAProposername")).lastName || '.'
    }
    else {
        emailID = valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFuturePersonelDetails", "email")?.toUpperCase()
        mobileNo = valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFuturePersonelDetails", "contactNo")
        countryCode =  valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFuturePersonelDetails", "mobileNumber")
        proposerfirstName =  fullNameCoverter(valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFuturePersonelDetails", "CPPersonalDetailName")).firstName
        proposermiddleName = fullNameCoverter(valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFuturePersonelDetails", "CPPersonalDetailName")).middleName
        proposerlastName =   fullNameCoverter(valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFuturePersonelDetails", "CPPersonalDetailName")).lastName || '.'
    }
    applicationJSON2['lifeAssuredDetails'] = {
        ...applicationJSON2['lifeAssuredDetails'],
        "fullName": fullNameCoverter(valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFuturePersonelDetails", "CPPersonalDetailName")).fullName,
        "firstName": fullNameCoverter(valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFuturePersonelDetails", "CPPersonalDetailName")).firstName,
        "middleName": fullNameCoverter(valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFuturePersonelDetails", "CPPersonalDetailName")).middleName,
        "lastName": fullNameCoverter(valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFuturePersonelDetails", "CPPersonalDetailName")).lastName || '.',
        "gender": valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFuturePersonelDetails", "GOPAgender"),
        "dob": valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFuturePersonelDetails", "GOPAdob"),
        "emailId": valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFuturePersonelDetails", "email"),
        "isLaAndPropSame": valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFuturePersonelDetails", "GOPAslifetobeAssuredandProposer"),
        "proofOfIdentity": valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionCommonResidenceAndOccupation", "ageIdentityProof") || valueParser(payload, "PageFlexiEdgeFillProposalForm", "SectionFlexiEdgeFillProposalPersonalDetail", "ageIdentityProof"),
        "maritalStatus"  : valueParser(payload, "PageFlexiEdgeFillProposalForm", "SectionFlexiEdgeFillProposalPersonalDetail", "martialStatus"),
        "countryOfBirth": valueParser(payload, "PageFlexiEdgeFillProposalForm", "SectionFlexiEdgeFillProposalPersonalDetail", "countryofbirth") || valueParser(payload, "PageFlexiEdgeFillProposalForm", "SectionFlexiEdgeFillProposalPersonalDetail", "countryOfBirth"),
        "citizenship": valueParser(payload, "PageFlexiEdgeFillProposalForm", "SectionFlexiEdgeFillProposalPersonalDetail", "citizenship"),
        "nationality": valueParser(payload, "PageFlexiEdgeFillProposalForm", "SectionFlexiEdgeFillProposalPersonalDetail", "nationality"),
        
        "communicationDetails": {
            "contactDetails": {
                "mobileNo": valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFuturePersonelDetails", "contactNo"),
                "countryCode":lookup.phoneCountryCodeDupeMapper[0][valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFuturePersonelDetails", "mobileNumber")],
                "countryCodeMap": valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFuturePersonelDetails", "mobileNumber"),
                "emailId": valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFuturePersonelDetails", "email")?.toUpperCase(),
            },
            "currentAddress": {
                "country": valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionCommonResidenceAndOccupation", "GOPAcountry") ? valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFuturePersonelDetails", "GOPAcountry") :lookup.countryCodeToCountry[0][valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFuturePersonelDetails", "mobileNumber")],
                "state": valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionCommonResidenceAndOccupation", "GOPAstate"),
                "pinCode": valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionCommonResidenceAndOccupation", "GOPApincode"),
                "cityMap": valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionCommonResidenceAndOccupation", "GopaCity"),
                "cityDistrict": payload.PageGuaranteedFutureCalculatePremium?.SectionGuaranteedFuturePersonelDetails?.GopaCity !== "OTHERS" ? valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionCommonResidenceAndOccupation", "GopaCity") :  valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionCommonResidenceAndOccupation", "citytextgsp"),
            }
        },
        "employmentDetails": {
            "annualIncome": valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFuturePersonelDetails", "GOPAannualIncome"),
            "education": valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFuturePersonelDetails", "GOPAeducationQualification"),
            "occupation": valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionCommonResidenceAndOccupation", "GOPAyouAre"),
            "natureOfOccupation": valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionCommonResidenceAndOccupation", "GOPAexactNatureOfOccupation"),
            "employerIndustry": valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionCommonResidenceAndOccupation", "GOPAnatureOfIndustry") ,
            "staff": valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionCommonResidenceAndOccupation", "FlexiCPemployeeOfCanaraHSBC"),
            "staffId": valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionCommonResidenceAndOccupation", "CPemployeeID"),
            "employerName": valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionCommonResidenceAndOccupation", "CPcompanyName"),
            "otherEmployerName": lookup.groupComapny[0][valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionCommonResidenceAndOccupation", "CPcompanyName")] || ''
        },
    }

    applicationJSON2['proposerDetails'] = {
        ...applicationJSON2['proposerDetails'],
        // "proposerDetails.payorSameAsLA":  valueParser(payload, "PageGuaranteedSavingsCalculatePremium", "SectionGuaranteedSavingsPersonelDetails", "islifetobeAssuredandProposer"),
        "fullName": fullNameCoverter(valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFuturePersonelDetails", "GOPAProposername")).fullName,
        "firstName": fullNameCoverter(valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFuturePersonelDetails", "GOPAProposername")).firstName,
        "middleName": fullNameCoverter(valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFuturePersonelDetails", "GOPAProposername")).middleName,
        "lastName": fullNameCoverter(valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFuturePersonelDetails", "GOPAProposername")).lastName || '.',
        "proposerDetails.dob": valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFuturePersonelDetails", "GOPAproposerDateOfBirth"),
        "proposerDetails.gender": valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFuturePersonelDetails", "GOPAproposerGender"),
        
        "communicationDetails": {
            "contactDetails": {
                "mobileNo": valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFuturePersonelDetails", "GOPAnumber"),
                "countryCode": valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFuturePersonelDetails", "GOPAproposerCode"),
                "emailId": valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFuturePersonelDetails", "GOPAproposerEmail")?.toUpperCase()
            }
        },

        "employmentDetails": {
            "annualIncome":valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFuturePersonelDetails", "GOPAproposerAnnualIncome"),
            "education": valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFuturePersonelDetails", "GOPAproposerEducationalQualification"),
        },

    }

    applicationJSON2["productDetails"] = {
        ...applicationJSON2["productDetails"],
        "consentPrivacyWaived": valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFuturePersonelDetails", "privacyPolicy") || false,
        "gstWaiverInd": valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFuturePersonelDetails", "GIAPNreAccount") || "N",
        "policyTerm": policyTermValue(payload?.PageGuaranteedFutureCalculatePremium?.SectionGuaranteedFutureSumAssured?.guaranteedFuturePT, payload?.PageGuaranteedFutureCalculatePremium?.SectionGuaranteedFuturePersonelDetails?.dateOfBirth),
        "ptValue": valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFutureSumAssured", "guaranteedFuturePT"),
        "premiumPaymentTerm": valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFutureSumAssured", "guaranteedFuturePPT"),
        "modeOfPayment": valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFutureSumAssured", "guaranteedFuturePF"),
        "premiumFrequency": valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFutureSumAssured", "guaranteedFuturePF"),
        "planOption":  valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFutureSumAssured", "guaranteedFuturePlanOption"),
        "planCoverage":  valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFutureSumAssured", "guaranteedFuturePlanOption") ,
        "planName":  valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFutureSumAssured", "guaranteedFuturePlanOption"),
        "installmentPremium": valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFutureSumAssured", "guaranteedFutureInstallmentPremium"),
        "modalPrem": valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFutureSumAssured", "guaranteedFutureInstallmentPremium"),
        "sumAssured" : valueParser(payload,"PageGuaranteedFutureCalculatePremium","SectionGuaranteedFutureSumAssured","alphaSumAssured"),
        "sso" : valueParser(payload,"PageGuaranteedFutureCalculatePremium","Promise4GrowthPlusPortfolioManangementSection","optionForSSO"),
        "funds" : []
    }

    applicationJSON2["basicDetails"] = {
        ...applicationJSON2["basicDetails"],
        "referrerName": valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFuturePersonelDetails", "referrerNameGIAP"),
        "referrerId": valueParser(payload, "PageGuaranteedFutureCalculatePremium", "SectionGuaranteedFuturePersonelDetails", "referrerIdGIAP"),  
        "emailID" : emailID,
        "mobileNo": mobileNo,
        "countryCode": countryCode 
    }

    applicationJSON2["journeyDetailsDirectKeys"] = {
        ...applicationJSON2["journeyDetailsDirectKeys"],
        "bankDetails": {
            "receivingRefundOrPayments": {
                "firstName":proposerfirstName,
                "middleName":proposermiddleName,
                "lastName":proposerlastName
            }
        }
    }
            
    
    if(pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalPersonalDetail" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalInsuranceHistory" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalHealth&LifestyleDetails" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalCommunicationAddress" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillproposalOccupationDetails" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalMedicalInformation" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalNomineeDetails" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.FlexiEdgeFillProposalAppointeeSection" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalPEPQuestionaire" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalProposerPEPQuestionaire" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalProposerDetails" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalNriQuestionaires" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalProposerNriQuestionaires" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalCovidQuestionnaire" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeBankDetailsOfProposer" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeOccupationalQuestionnaireSectionOil" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeOccupationalQuestionnaireSectionMarine" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeOccupationalQuestionnaireSectionMining" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeOccupationalQuestionnaireSectionDefence" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFemaleMedicalQuestionaire" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.sectionGOPAJointLifeQuestionnaire" ||
    pageIndicator === "PageFlexiEdgeFillProposalForm.reviewDetailsflexiEdge" || 
    pageIndicator === "makePayment.make-Payment" ||
    pageIndicator === "makePayment.successful-transaction" ||
    pageIndicator === "makePayment.unsuccessful-transaction" ||
    pageIndicator === "makePayment.pending-transaction" ||
    pageIndicator === "makePayment.eNach-physicalMandate" ||
    pageIndicator === "PageFlexiEdgeUploadDocuments.declaration" ||
    pageIndicator === "PageFlexiEdgeUploadDocuments.UploadDocuments" ||
    pageIndicator === "PageFlexiEdgeUploadDocuments.application-submission" 
    ){
        applicationJSON2  = commonProposalFormApplicationMapper(payload, journeyId, pageId, sectionId, applicationJSON2)
    }
    return applicationJSON2
}
